import React, { Children, PropsWithChildren } from 'react'
import styles from './Modal.module.scss'
import styled from 'styled-components'

type ModalType = {
    onClickToggleModal?: () => void,
    width: number,
    height?: number,
    background: boolean,
    radius: boolean,
    type?: string,
    z_index? : number
}



const ModalContainer = styled.div<{$type?:string }>`
    position: fixed;
    display: flex;
    justify-content: center;
    align-items: center;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 100;
`
const DialogBox = styled.div<{$width:number, $height?: number, $radius: boolean, $type?:string, $z_index?: number, $background: boolean}>`
    width: ${(props) => props.$width}px;
    ${(props) => props.$height ? "height:" + props.$height + "px;" : ""}
    ${(props) => props.$background ? "" : "box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.16);"}
    // display: flex;
    // align-items: center;
    background-color: #FFFFFF;
    padding: 24px;
    z-index: ${(props) => props.$z_index ? props.$z_index : 5000};
    border-radius: ${(props) => props.$radius ? "8" : "0"}px;
`



const Modal = ({onClickToggleModal, width, height, background, radius, type, children, z_index }: PropsWithChildren<ModalType>) => {


    return (
        <ModalContainer>
            <DialogBox className = {type === "calculateDetails" ? 'responsive _width_100' : ''} $width = {width} $height = {height} $radius = {radius} $type = {type} $z_index = {z_index} $background = {background}>{children}</DialogBox>
        </ModalContainer>
    )
}

export default Modal

